export const API_ROOT =
  process.env.NODE_ENV === "production"
    ? "https:/time-e.schwarzl-it.com/api/"
    : "/api/";
export const WS_ROOT =
  process.env.NODE_ENV === "production"
    ? "https://time-e.schwarzl-it.com/"
    : // ? "https://obs.schwarzl-it.com/"
      "http://localhost:8905/";
